import React from "react";

export function MobilePage({ children, className = "" }) {
  return (
    <div className={`min-h-screen bg-[#f4f8ff] pb-24 text-slate-950 ${className}`}>
      <main className="mx-auto max-w-md px-4 pt-5 space-y-4">{children}</main>
    </div>
  );
}

export function GlassCard({ children, className = "" }) {
  return (
    <div className={`rounded-[28px] border border-white/70 bg-white/80 shadow-[0_20px_60px_rgba(37,99,235,0.12)] backdrop-blur-xl ${className}`}>
      {children}
    </div>
  );
}

export function PrettyStatCard({ title, value, subtitle, icon: Icon, gradient = "from-blue-500 to-cyan-500", soft = "from-blue-50 to-cyan-50" }) {
  return (
    <div className={`relative overflow-hidden rounded-[24px] border border-white/80 bg-gradient-to-br ${soft} p-4 shadow-sm`}>
      <div className="absolute -right-8 -bottom-8 h-24 w-24 rounded-full bg-white/60 blur-xl" />
      <div className="relative flex items-start gap-3">
        <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br ${gradient} text-white shadow-lg`}>
          {Icon && <Icon className="h-6 w-6" />}
        </div>
        <div className="min-w-0">
          <div className="text-[11px] font-extrabold uppercase tracking-wider text-slate-500">{title}</div>
          <div className="mt-1 text-2xl font-black leading-tight text-slate-950">{value}</div>
          {subtitle && <div className="mt-1 text-xs text-slate-500">{subtitle}</div>}
        </div>
      </div>
    </div>
  );
}

export function PrettyActionCard({ title, subtitle, badge, icon: Icon, imageIcon: ImageIcon, gradient = "from-blue-500 to-cyan-500", badgeClass = "bg-blue-50 text-blue-700 border-blue-100", onClick }) {
  return (
    <button
      onClick={onClick}
      className="group w-full overflow-hidden rounded-[26px] border border-white/80 bg-white/90 p-4 text-left shadow-[0_16px_45px_rgba(15,23,42,0.08)] transition active:scale-[0.99]"
    >
      <div className="flex items-center gap-4">
        <div className={`flex h-16 w-16 shrink-0 items-center justify-center rounded-3xl bg-gradient-to-br ${gradient} text-white shadow-lg shadow-blue-200/50`}>
          {Icon && <Icon className="h-8 w-8" />}
        </div>

        <div className="min-w-0 flex-1">
          <div className="text-lg font-black tracking-tight text-slate-950">{title}</div>
          <div className="mt-0.5 text-sm text-slate-500">{subtitle}</div>
          {badge && (
            <div className={`mt-2 inline-flex items-center rounded-full border px-2.5 py-1 text-[11px] font-bold ${badgeClass}`}>
              {badge}
            </div>
          )}
        </div>

        {ImageIcon && (
          <div className="hidden sm:flex h-16 w-20 items-center justify-center text-slate-300">
            <ImageIcon className="h-12 w-12 opacity-70" />
          </div>
        )}

        <div className="text-2xl text-slate-400 transition group-active:translate-x-1">›</div>
      </div>
    </button>
  );
}
